import { lazy } from 'react';

export const AdminRealTimeStatistics = lazy(() => import('./pages/AdminRealTimeStatistics'));

export { useAdminRealTimeStatisticsData } from './hooks/use-admin-real-time-statistics-data';
